export default class ChevronToggle {
  constructor() {
    this.upIcon = "glyphicon-chevron-up";
    this.downIcon = "glyphicon-chevron-down";
    $("[data-chevron-toggle]").
      addClass(this.upIcon).
      addClass("glyphicon");

    this.bindHandlers()
  }

  bindHandlers() {
    N2.handle("click", "[data-chevron-toggle]", (evt) => {
      let $glyph = $(evt.target);
      let $expand = $('#' + $glyph.data("target"));
      $expand.toggle();

      $glyph.toggleClass(this.downIcon);
      $glyph.toggleClass(this.upIcon);
    });
  }
}
